export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20soft%20flowing%20geometric%20shapes%20in%20coral%20and%20amber%20tones%2C%20modern%20minimalist%20tech%20aesthetic%2C%20smooth%20organic%20curves%2C%20digital%20atmosphere%2C%20clean%20composition%2C%20luxurious%20feel%2C%20no%20text%2C%20no%20people%2C%20subtle%20light%20rays%20from%20top%20right%20corner&width=1800&height=900&seq=hero-bg-ky-01&orientation=landscape"
          alt="KY App 官方下载入口"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-white mb-4 leading-tight">
            www.ky.app 官方入口
          </h1>
          <p className="text-base md:text-lg text-white/80 mb-3 leading-relaxed max-w-2xl mx-auto">
            极速下载 · 安全安装 · 稳定流畅
          </p>
          <p className="text-sm md:text-base text-white/60 mb-8 max-w-xl mx-auto leading-relaxed">
            KY应用官方指定地址，提供最新版本下载与账号注册服务，支持iOS与Android双平台
          </p>

          {/* Download Buttons */}
          <div id="download" className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#"
              className="group flex items-center gap-3 px-8 py-3.5 rounded-full bg-white text-foreground-900 font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-white/90 transition-all duration-200 hover:scale-105"
            >
              <i className="ri-apple-fill text-xl"></i>
              <div className="text-left">
                <div className="text-xs text-foreground-500">Download on the</div>
                <div className="text-base font-semibold">App Store</div>
              </div>
            </a>
            <a
              href="#"
              className="group flex items-center gap-3 px-8 py-3.5 rounded-full bg-primary-500 text-white font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-all duration-200 hover:scale-105"
            >
              <i className="ri-android-fill text-xl"></i>
              <div className="text-left">
                <div className="text-xs text-white/70">Download for</div>
                <div className="text-base font-semibold">Android APK</div>
              </div>
            </a>
          </div>

          <p className="mt-6 text-xs text-white/40">
            推荐使用手机浏览器访问 www.ky.app 获得最佳下载体验
          </p>
        </div>
      </div>
    </section>
  );
}